<template>
  <div class="form-group mb-0">
    <div :class="hasIcon(icon)">
      <label v-if="useLabel" :for="id" class="form-label">
        {{ label }}
      </label>
      <span v-if="iconDir === 'left'" class="input-group-text">
        <i :class="getIcon(icon)"></i>
      </span>
      <Field
        :id="id"
        :type="type"
        class="form-control"
        :class="getClasses(size, success, error)"
        :name="name"
        :placeholder="!useLabel ? placeholder : ''"
        :required="isRequired"
        v-model="internalValue"
        :maxlength="largo"
        :readonly="readonly"
        :autocomplete="autocomplete"
        @input="$emit('update:modelValue', $event.target.value)"
      />
      <ErrorMessage
        :name="name"
        class="error-feedback text-xs text-danger"
        role="alert"
      />
      <span v-if="iconDir === 'right'" class="input-group-text">
        <i :class="getIcon(icon)"></i>
      </span>
    </div>
  </div>
</template>

<script>
import { Field, ErrorMessage } from "vee-validate";
export default {
  name: "SoftInput",
  components: {
    Field,
    ErrorMessage,
  },
  props: {
    size: {
      type: String,
      default: "default",
    },
    success: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "",
    },
    iconDir: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    modelValue: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "Type here...",
    },
    type: {
      type: String,
      default: "text",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    largo: {
      type: String,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    autocomplete: {
      type: String,
      default: "",
    },
    useLabel: {
      type: Boolean,
      default: false, 
    },
    label: {
      type: String,
      default: "", 
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      internalValue: this.modelValue, // Mantiene un valor interno para sincronización
    };
  },
  watch: {
    modelValue(newValue) {
      this.internalValue = newValue;
    },
    internalValue(newValue) {
      this.$emit("update:modelValue", newValue); 
    },
  },
  methods: {
    getClasses: (size, success, error) => {
      let sizeValue, isValidValue;

      sizeValue = size ? `form-control-${size}` : null;

      if (error) {
        isValidValue = "is-invalid";
      } else if (success) {
        isValidValue = "is-valid";
      } else {
        isValidValue = "";
      }

      return `${sizeValue} ${isValidValue}`;
    },
    getIcon: (icon) => (icon ? icon : null),
    hasIcon: (icon) => (icon ? "input-group" : null),
  },
};
</script>
<style scoped>

/* Skin Quanty */
.form-control{
  background-color: var(--q-hover);
  border-color: var(--q-border-md);
  color: var(--q-text);
  border-radius:10px;
}
.form-control:focus{
  border-color: var(--q-gold);
  box-shadow: 0 0 0 3px rgba(245,166,35,0.2);
  outline:none;
}
</style>